(() => {
  if (customElements.get('faq-popup')) return;

  class FaqPopup extends HTMLElement {
    constructor() {
      super();
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.querySelectorAll('[data-action="close"]').forEach((el) =>
        el.addEventListener('click', this.onClose)
      );

      document.addEventListener('click', this.onTriggerClick);
      document.addEventListener('keydown', this.onKeyDown);
    }

    disconnectedCallback() {
      this.querySelectorAll('[data-action="close"]').forEach((el) =>
        el.removeEventListener('click', this.onClose)
      );
      document.removeEventListener('click', this.onTriggerClick);
      document.removeEventListener('keydown', this.onKeyDown);
    }

    isOpen() {
      return this.getAttribute('aria-hidden') === 'false';
    }

    onTriggerClick(event) {
      const link = event.target.closest('a[href="#faq"]');
      if (!link) return;
      event.preventDefault();
      this.lastFocus = link;
      this.open();
    }

    open() {
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.querySelector('.faq-popup__close')?.focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
    }

    onClose() {
      this.close();
    }

    onKeyDown(event) {
      if (!this.isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab') {
        this.trapFocus(event);
      }
    }

    trapFocus(event) {
      const focusable = Array.from(
        this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.getClientRects().length > 0);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('faq-popup', FaqPopup);
})();